import * as React from 'react';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive';
}

export const Alert: React.FC<AlertProps> = ({ variant = 'default', className, children, ...props }) => {
  return (
    <div
      className={`rounded px-4 py-2 text-sm font-medium mb-2 border ${
        variant === 'destructive'
          ? 'bg-red-50 text-red-800 border-red-200'
          : 'bg-gray-50 text-gray-800 border-gray-200'
      } ${className || ''}`}
      {...props}
    >
      {children}
    </div>
  );
};
